import { render } from "./ClientText.vue?vue&type=template&id=515898ca"
import script from "./ClientText.vue?vue&type=script&lang=js"
export * from "./ClientText.vue?vue&type=script&lang=js"

import "./ClientText.vue?vue&type=style&index=0&id=515898ca&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__